import classNames from 'classnames';
import React from 'react';

import Button from 'sharedreact/components/Button';
import LinkWithContext from 'sharedreact/components/LinkWithContext';
import withFormValidationProps from 'sharedreact/components/withFormValidationProps';

type Props = {
  id: string,
  className?: string,
  disabled?: boolean,
  type?: string
  icon?: string,
  badgeValue?: React.ReactNode,
  children?: React.ReactNode,
  collapsable?: boolean,
  onlyShowIconWhenCollapsed?: boolean,
  active?: boolean,
  autoFocus?: boolean,
  title?: string,
  to?: string
};

type DefaultProps = Required<Pick<Props, 'type'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class LinkButton extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    type: 'btn-default'
  };

  override render (): React.ReactNode {
    const {
      id, className, disabled, to, type, icon, badgeValue,
      children, collapsable, onlyShowIconWhenCollapsed, active,
      autoFocus, title
    } = (this.props as PropsWithDefaults);

    const buttonDisabled = !to || disabled;
    const buttonClassName = classNames('esko_btn', type.split(' ').map(className => 'esko_' + className).join(' '), className, {
      active: active
    });

    if (buttonDisabled) {
      return (
        <Button id={id}
          className={className}
          type={type}
          icon={icon}
          badgeValue={badgeValue}
          collapsable={collapsable}
          disabled
          onlyShowIconWhenCollapsed={onlyShowIconWhenCollapsed}
          active={active}
          autoFocus={autoFocus}
          title={title}
        >
          {children}
        </Button>
      );
    }

    if (icon != null) {
      if (collapsable) {
        if (onlyShowIconWhenCollapsed) {
          return (
            <LinkWithContext id={id}
              to={to}
              type='button'
              className={buttonClassName}
              title={title}
            >
              <div className='esko_visible-lg-inline esko_visible-md-inline'>
                {children}
              </div>
              <div className='esko_visible-xs-inline esko_visible-sm-inline'>
                <span className={icon}>
                  {badgeValue}
                </span>
              </div>
            </LinkWithContext>
          );
        } else {
          return (
            <LinkWithContext id={id}
              to={to}
              type='button'
              className={buttonClassName}
              title={title}
            >
              <div className='esko_visible-lg-inline esko_visible-md-inline'>
                <span className={icon}>{badgeValue}</span> {children}
              </div>
              <div className='esko_visible-xs-inline esko_visible-sm-inline'>
                <span className={icon}>
                  {badgeValue}
                </span>
              </div>
            </LinkWithContext>
          );
        }
      } else {
        return (
          <LinkWithContext id={id}
            to={to}
            type='button'
            className={buttonClassName}
            title={title}
          >
            <span className={icon}>{badgeValue}</span> {children}
          </LinkWithContext>
        );
      }
    } else {
      return (
        <LinkWithContext id={id}
          to={to}
          type='button'
          className={buttonClassName}
          title={title}
        >
          {children}
        </LinkWithContext>
      );
    }
  }
}

export default withFormValidationProps(LinkButton);
